<template>
		<b-row>
			<b-col cols="12">
				<b-form-row>
					<b-col v-if="labelSize != 0" :cols=labelSize>
						<label class="col-form-label col-form-label-sm  pt-0">{{ label }} <span v-if="required" class="text-danger"> * </span></label>
					</b-col>
					<b-col :cols="labelSize == 0 ? 12 : fieldSize">
						<b-input-group size="sm" class="shodowed-group">
							<b-form-input  v-if="!disabled" :state="isValid"  size="sm" v-model="localValue" :placeholder="label"></b-form-input>
							<b-form-input v-if="disabled"  readonly size="sm" v-model="localValue" :placeholder="label"></b-form-input>
							<b-input-group-addon>
								<b-button v-if="!disabled" type="button" @click="generateValue" size="sm" variant="outline-default">
									<i class="fa fa-refresh"></i>
								</b-button>
								<b-button disabled v-if="disabled" type="button" @click="generateValue" size="sm" variant="outline-default">
									<i class="fa fa-refresh"></i>
								</b-button>
							</b-input-group-addon>
						</b-input-group>
					</b-col>
				</b-form-row>

			</b-col>
		</b-row>
</template>

<script>
    import ApiService from "../../services/api.service";

	export default {
        name: 'AsyncInput',

		props: {
			value: {
			},
			label: {
				type: String,
				default:''
			},
			labelSize: {
				type: Number,
				default: 2
			},
			fieldSize: {
				type: Number,
				default: 10
			},
			entityPoint: {
				type: String,
				default: ''
			},
			fullItem: {
				default: {},
				type: Object
			},
			disabled: {
				type: Boolean,
				default: false
			},
			states: {
			},
			required: {
				default: false
			}
		},
		data() {
			return {
				localValue: this.value
			}
		},

		watch: {
			value(newVal, oldVal) {
				this.localValue = newVal
			},
			localValue(newVal, oldVal) {
				this.$emit('input', this.localValue)
			}
		},
		methods: {
        	generateValue() {
        		ApiService.post(this.entityPoint, this.fullItem).then(response => {
        			this.localValue = response.data;
				})
			}
		},
		computed: {
			isValid() {
				if (this.states && this.isChanged) {
					return  this.states.valid;
				}
				if (this.states && this.isTouched) {
					return  this.states.valid;
				}
				if (this.states && this.isDirty) {
					return  this.states.valid;
				}
				return null;
			},
			isChanged() {
				return this.states.changed
			},
			isTouched() {
				return this.states.touched
			},
			isDirty() {
				return this.states.touched
			},


		}
    }
</script>

<style scoped>

</style>
